import { ColumnManager } from './ColumnManager'

// Determine column type based on orders and original-order indicator
export function getColumnType(columnKey, orders, hasOriginalOrderQuantity) {
  if (!columnKey) return 'deletable'

  // original order takes precedence
  if (typeof hasOriginalOrderQuantity === 'function') {
    try {
      if (hasOriginalOrderQuantity(columnKey)) return 'original-order'
    } catch (e) {
      // fallthrough
    }
  }

  // Orders are matched by customer and branch only, so they belong to the
  // first column of that pair. Columns the user adds with the same codes get
  // index 1, 2, ... and stay ordinary editable columns.
  const { customerCode, branchCode, index } =
    ColumnManager.parseColumnKey(columnKey)
  if (index > 0) return 'deletable'

  // check presence of orders
  if (orders && Array.isArray(orders) && orders.length > 0) {
    const targetCode = String(customerCode ?? '')
    const targetBranch = String(branchCode ?? '')

    const found = orders.some((entry) => {
      const ordersList = entry.orders_list || []
      return ordersList.some((o) => {
        return (
          String(o.customer_code ?? o.CUSTOMER_CODE ?? '') === targetCode &&
          String(o.branch_code ?? o.BRANCH_CODE ?? '') === targetBranch
        )
      })
    })

    if (found) return 'has-order'
  }

  return 'deletable'
}

export function getColumnTypeClass(type) {
  switch (type) {
    case 'has-order':
      return 'customer-type-has-order'
    case 'original-order':
      return 'customer-type-original-order'
    case 'deletable':
    default:
      return 'customer-type-deletable'
  }
}

export default getColumnType
